export function handleSuggestion(suggestions, includeList) {
    let suggestionList = [];
    let includeMap = null;
    if (includeList && includeList.length) {
        // filter 
        includeMap = includeList
            .map(v => v.split(','))
            .flat(1)
            .reduce((m, k) => Object.assign(m, { [k]: true }), {});
    }
    for (let i = 0; i < suggestions.length; i++) {
        let { list, typeText, type } = suggestions[i];
        typeText ??= type;
        if (!list.length) {
            continue;
        }
        if (includeMap && !includeMap[type]) {
            continue;
        }
        //  right suggestion Sort 
        suggestionList[i] = [{ label: typeText }].concat(
            list.map(it => ({ type, label: it.label, value: it.value }))
        );
    }
    return suggestionList.flat(1).filter(Boolean);
}

/**
 *  get the first suggestion object 
 * @param {*} suggestionList
 * @param {*} item
 * @returns
 */
export function getFirstSuggestion(suggestionList, item) {
    if (item) {
        let { type, value } = item;
        for (let i = 0; i < suggestionList.length; i++) {
            let suggestionItem = suggestionList[i];
            if (suggestionItem.value == value && suggestionItem.type == type) {
                return suggestionItem;
            }
        }
    }
    for (let i = 0; i < suggestionList.length; i++) {
        if (suggestionList[i].value) {
            return suggestionList[i];
        }
    }
    return null;
}
